module.exports = __webpack_public_path__ + "static/pre-cadastro-medico-fc67864fca8f48085724bcc959e5c4b9.png";